module.exports = __webpack_public_path__ + "img/56150-capital-investment.036e562d.gif";